import React, { useEffect, useState } from 'react';
import { Box, FormControl, FormHelperText, Button } from '@material-ui/core';
import { useSelector, useLocation } from 'umi';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import {
  TextFieldCom,
  UploadImageCom,
  RadioFieldCom,
  CheckBoxFieldCom,
  SelectFieldCom,
} from '@/components/FormType';
import DialogMl from './Dialog';
import webStorage from '@/utils/storageManager';
import { OPT_DETAIL, OPT_ADD } from '@/constants';
import { fmtThousand } from '@/utils/comUtil';
import CouponModal from './CouponModal/CouponModal';
import DateRangePickerML from '@/components/DateRangePickerML';

export default ({
  control,
  setValue,
  getValues,
  errors,
  couponInfo,
  watchAllFields,
  setCouponInfo,
}) => {
  const ACTIVITY_POINTS_GIFT_TYPE =
    webStorage.get('DICTOBJ')?.ACTIVITY_POINTS_GIFT_TYPE;
  const GIFT_TYPE = ACTIVITY_POINTS_GIFT_TYPE.map((item) => ({
    label: item.nameZh === '实物' ? '实物邮寄' : item.nameZh,
    value: item.dictCode,
  }));
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};
  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  const { detailInfo: defaultValues } = useSelector(
    (state) => state.managementGiftForm,
  );
  //会员等级列表
  const memberLevels =
    useSelector((state) => state.luckDrawViewSetting.memberLevels) || [];
  const location = useLocation();
  const { query } = location;
  const { id, opt } = query;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState();
  const [openModal, setOpenModal] = useState(false);
  //当前视口宽度
  const clientWidth = document.body.clientWidth;
  //当前视口高度
  const clientHeight = document.body.clientHeight;
  const [initStock, setInitStock] = useState('');
  const [initSurplusStock, setInitSurplusStock] = useState('');
  const handlePreviewClose = () => {
    setPreviewUrl();
    setPreviewOpen(false);
  };
  //点击图片预览
  const handlePreview = (imgUrl) => {
    setPreviewUrl(imgUrl);
    setPreviewOpen(true);
  };

  useEffect(() => {
    console.log(defaultValues, 'defaultValues');

    if (defaultValues && id) {
      for (let v in defaultValues) {
        if (v === 'couponInfo') {
          const coupons = defaultValues[v]
            ? { ...defaultValues[v], id: defaultValues[v].couponId }
            : '';
          coupons && setCouponInfo(coupons);
        } else if (v === 'receiveMethod') {
          defaultValues[v]
            ? setValue(v, defaultValues[v])
            : setValue(v, 'TAKE_THEIR');
        } else {
          setValue(v, defaultValues[v]);
        }
      }
      setInitStock(defaultValues.stock || 0);
      setInitSurplusStock(defaultValues.surplusStock || 0);
    }
  }, [defaultValues, setValue, id]);

  const CouponSelectContent = ({ children, info }) => (
    <Box>
      <Box className="card_wrapper">
        {info?.couponId ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="12px 0"
          >
            <Box className="card_item">
              <Box
                sx={{
                  width: '238px',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                }}
              >
                <Box
                  sx={{
                    color: '#1565C0',
                    fontSize: '16px',
                    fontWeight: 600,
                    lineHeight: '22px',
                  }}
                >
                  {info.couponName}
                </Box>
                <Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      color: '#BDC0C4',
                    }}
                  >
                    优惠券 有效期
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#424242',
                      gap: '0 2px',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                        lineHeight: '22px',
                      }}
                    >
                      {dayjs(info.beginTime).format('YYYY-MM-DD')}
                    </Box>
                    <Box
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        lineHeight: '14px',
                        transform: 'scale(0.83)',
                      }}
                    >
                      至
                    </Box>
                    <Box
                      sx={{
                        fontSize: '16px',
                        fontWeight: 600,
                        lineHeight: '22px',
                      }}
                    >
                      {dayjs(info.endTime).format('YYYY-MM-DD')}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  flex: 1,
                  height: '100%',
                  paddingLeft: '35px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'column',
                }}
              >
                <Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      color: '#BDC0C4',
                    }}
                  >
                    优惠券 ID
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#424242',
                      gap: '0 2px',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: '19.2px',
                        fontWeight: 600,
                        lineHeight: '22px',
                        transform: 'scale(0.83)',
                        marginLeft: '-4px',
                      }}
                    >
                      {info.couponId}
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Box
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      lineHeight: '22px',
                      color: '#BDC0C4',
                    }}
                  >
                    优惠券 类型
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      color: '#424242',
                      gap: '0 2px',
                    }}
                  >
                    <Box
                      sx={{
                        fontSize: '19.2px',
                        fontWeight: 600,
                        lineHeight: '22px',
                        transform: 'scale(0.83)',
                        marginLeft: '-4px',
                      }}
                    >
                      {
                        typeList.find(
                          (it) =>
                            it.value === info.typeName ||
                            it.value === info.couponType,
                        )?.name
                      }
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            {opt !== OPT_DETAIL && (
              <Box
                sx={{
                  display: 'flex',
                  gap: '0 16px',
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenModal(true);
                  }}
                  sx={{
                    width: '68px',
                    borderRadius: '24px',
                    height: '36px',
                    lineHeight: '36px',
                  }}
                >
                  替换
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setCouponInfo();
                  }}
                  sx={{
                    width: '68px',
                    borderRadius: '24px',
                    color: '#F50057',
                    borderColor: '#F50057',
                    height: '36px',
                    lineHeight: '36px',
                  }}
                >
                  删除
                </Button>
              </Box>
            )}
          </Box>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            gap="12px 0"
          >
            <Box className="addRule"></Box>
            {children}
          </Box>
        )}
      </Box>
    </Box>
  );

  const handleAddCouponClick = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onConfirm = (data) => {
    const couponData = {
      ...data,
      couponId: data.id,
      couponName: data.title,
      couponType: data.couponType,
    };
    setCouponInfo(couponData);
  };

  const handleInitEvent = (value) => {
    if (opt === OPT_ADD) {
      setValue('surplusStock', value);
    } else {
      const stock = value ? value.replace(/,/g, '') : '';
      const oldStock = initStock ? initStock.replace(/,/g, '') : '';
      const oldSurplusStock = initSurplusStock
        ? initSurplusStock.replace(/,/g, '')
        : '';
      const newStock =
        Number(stock) - Number(oldStock) + Number(oldSurplusStock);
      setValue('surplusStock', newStock ? fmtThousand(newStock) : '');
    }
  };
  return (
    <Box display="flex" flexDirection="column">
      <Box
        sx={{
          color: '#212121',
          fontSize: '18px',
          fontWeight: '600',
          marginBottom: '32px',
        }}
      >
        基本设置
      </Box>
      <Box className="display-column-between" gap="32px 0">
        <Box sx={{ display: 'flex', gap: '0 48px', alignItems: 'flex-end' }}>
          <Box flex="1">
            <Box className="display-column-between" gap="32px 0">
              <TextFieldCom
                label="礼品标题"
                showError={true}
                control={control}
                name="title"
                setValue={setValue}
                getValues={getValues}
                disabled={opt === OPT_DETAIL}
                rules={{
                  required: true, //是否是必填项true 必填 false 非必填
                  maxLength: 25,
                }}
                errors={errors}
              />
              <Box sx={{ display: 'flex', gap: '0 48px' }}>
                <TextFieldCom
                  label="总库存"
                  showError={true}
                  control={control}
                  name="stock"
                  setValue={setValue}
                  getValues={getValues}
                  thousands={true}
                  isPositiveNumber={true}
                  isNumber={true}
                  disabled={opt === OPT_DETAIL}
                  rules={{
                    required: true, //是否是必填项true 必填 false 非必填
                    max: 9999999,
                  }}
                  errors={errors}
                  handleInitEvent={handleInitEvent}
                />
                <TextFieldCom
                  label="当前剩余库存"
                  showError={true}
                  control={control}
                  name="surplusStock"
                  setValue={setValue}
                  getValues={getValues}
                  thousands={true}
                  isPositiveNumber={true}
                  isNumber={true}
                  disabled={true}
                  errors={errors}
                />
              </Box>
              <Box
                sx={{
                  height: '44px',
                  background: '#F6F6F6',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 500,
                  color: '#333333',
                  lineHeight: '44px',
                  paddingLeft: '16px',
                }}
              >
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#999999',
                  }}
                >
                  礼品code
                </span>
                &nbsp;&nbsp;&nbsp; {defaultValues?.code}
              </Box>
            </Box>
          </Box>

          <Box flex="1">
            <TextFieldCom
              label="礼品描述"
              showError={true}
              control={control}
              name="description"
              setValue={setValue}
              getValues={getValues}
              disabled={opt === OPT_DETAIL}
              rules={{
                required: true, //是否是必填项true 必填 false
                maxLength: 2000,
              }}
              errors={errors}
              multiline={true}
              maxRows="6"
              minRows="6"
              variant="outlined"
              textClassName="textField-area-wrap"
              placeholder="请输入"
            />
          </Box>
        </Box>
        <Box>
          <RadioFieldCom
            getValues={getValues}
            setValue={setValue}
            name="exchangeMethod"
            control={control}
            labelWidth="200px"
            defaultValue="POINTS"
            typeList={[
              {
                value: 'POINTS',
                label: '积分兑换',
                isRightShow: true,
              },
              {
                value: 'CASH',
                label: '购买',
                isRightShow: true,
              },
            ]}
            disabled={opt === OPT_DETAIL}
            label="兑换方式"
            initLabel={true}
            style={{ flexDirection: 'row' }}
          />
          <Box sx={{ display: 'flex', gap: '0 92px' }}>
            <Box
              sx={{
                display: watchAllFields.exchangeMethod?.includes('POINTS')
                  ? 'block'
                  : 'none',
              }}
            >
              <TextFieldCom
                label="兑换所需积分值"
                showError={true}
                control={control}
                name="exchangePoint"
                setValue={setValue}
                getValues={getValues}
                thousands={true}
                isPositiveNumber={true}
                isNumber={true}
                disabled={opt === OPT_DETAIL}
                rules={{
                  required: watchAllFields.exchangeMethod?.includes('POINTS'), //是否是必填项true 必填 false 非必填
                  max: 999999,
                }}
                errors={errors}
              />
            </Box>
            <Box
              sx={{
                display: watchAllFields.exchangeMethod?.includes('CASH')
                  ? 'flex'
                  : 'none',
                alignItems: 'center',
                gap: '0 48px',
              }}
            >
              <TextFieldCom
                label="兑换所需金额"
                showError={true}
                control={control}
                name="exchangeCost"
                setValue={setValue}
                getValues={getValues}
                thousands={true}
                isPositiveNumber={true}
                isNumber={true}
                isParseInt={false}
                disabled={opt === OPT_DETAIL}
                rules={{
                  required: watchAllFields.exchangeMethod?.includes('CASH'), //是否是必填项true 必填 false 非必填
                  max: 999999.99,
                }}
                errors={errors}
              />
              <RadioFieldCom
                typeList={[
                  {
                    label: '不支持',
                    value: '0',
                  },
                  {
                    label: '支持',
                    value: '1',
                  },
                ]}
                control={control}
                name="isRefundable"
                label={
                  <span style={{ fontSize: '12px', marginBottom: '-12px' }}>
                    是否支持退
                  </span>
                }
                initLabel={true}
                defaultValue="0"
                disabled={opt === OPT_DETAIL}
              />
            </Box>
          </Box>
        </Box>

        <RadioFieldCom
          typeList={GIFT_TYPE}
          control={control}
          name="type"
          label="礼品类型"
          defaultValue="COUPON"
          disabled={opt === OPT_DETAIL}
          initLabel="礼品类型"
          callback={() => {
            setCouponInfo();
          }}
          rules={{
            validate: {
              //实物门店领取
              isToStore: () =>
                getValues('receiveMethod') === 'TAKE_THEIR' &&
                getValues('type') === 'REAL_PRIZE'
                  ? Boolean(couponInfo?.id)
                  : true,
              //发放优惠券
              isCoupon: () =>
                getValues('type') === 'COUPON' ? Boolean(couponInfo?.id) : true,
            },
          }}
        />

        {getValues('type') === 'COUPON' && (
          <CouponSelectContent info={couponInfo}>
            <Box
              mt={1.5}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                justifyContent: 'space-between',
                flexDirection: 'row-reverse',
              }}
            >
              <Button
                variant="contained"
                onClick={handleAddCouponClick}
                sx={{
                  marginRight: '24px',
                  width: '124px',
                  borderRadius: '24px',
                  height: '36px',
                  lineHeight: '36px',
                }}
                startIcon={
                  <InsertLinkIcon sx={{ width: '14px', height: '14px' }} />
                }
              >
                关联
              </Button>
              <Box
                mt={0.5}
                className="error_mention"
                style={{
                  ...(Boolean(errors.type?.type === 'isCoupon') && {
                    display: 'block',
                    color: '#f44336',
                    fontSize: '12px',
                  }),
                }}
              >
                请选择关联优惠券
              </Box>
            </Box>
          </CouponSelectContent>
        )}
        <Box
          sx={{ display: getValues('type') !== 'COUPON' ? 'block' : 'none' }}
        >
          <RadioFieldCom
            getValues={getValues}
            setValue={setValue}
            name="postageStatus"
            control={control}
            labelWidth="200px"
            defaultValue="0"
            typeList={[
              {
                value: '0',
                label: '不需要',
                isRightShow: true,
              },
              {
                value: '1',
                label: (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <span>需要</span>
                    <Box sx={{ marginLeft: '12px' }}>
                      <TextFieldCom
                        sx={{ width: '110px' }}
                        label="邮费金额"
                        control={control}
                        name="postageAmount"
                        setValue={setValue}
                        getValues={getValues}
                        thousands={true}
                        isPositiveNumber={true}
                        isNumber={true}
                        disabled={opt === OPT_DETAIL}
                        errors={errors}
                        defaultValue=""
                        isAdditionalRequired={!getValues('postageStatus')}
                        initErrorText="必填项"
                        rules={{
                          max: getValues('postageStatus') === '1' ? 999.99 : '',
                          min: getValues('postageStatus') === '1' ? 0 : '',
                          required: getValues('postageStatus') === '1',
                        }}
                      />
                    </Box>
                  </Box>
                ),
                isRightShow: true,
              },
            ]}
            disabled={opt === OPT_DETAIL}
            label="是否需要邮费"
            initLabel={true}
            style={{ flexDirection: 'row' }}
            callback={(value) => {
              const postageAmount = getValues('postageAmount');
              console.log(value, postageAmount);

              if (value === '1' && !postageAmount) {
                setValue('postageAmount', '12');
              } else if (value === '0' && postageAmount) {
                setValue('postageAmount', '');
              }
            }}
          />
        </Box>

        {/* ----------- */}
        <Box>
          <Box sx={{ fontSize: '12px', color: '#212100', lineHeight: '17px' }}>
            礼品有效期
            <span style={{ color: '#999999', marginLeft: '4px' }}>
              小程序积分商城仅会展示在有效期内的礼品
            </span>
          </Box>
          <FormControl variant="standard">
            <Controller
              render={(rp) => (
                <DateRangePickerML
                  label="开始时间"
                  title="结束时间"
                  minDate={(!id && new Date()) || null}
                  startText={
                    <>
                      <span style={{ color: 'red' }}>*</span>
                      开始时间
                    </>
                  }
                  endText={
                    <>
                      <span style={{ color: 'red' }}>*</span>
                      结束时间
                    </>
                  }
                  defaultStartDate={defaultValues?.date?.startDate}
                  defaultEndDate={defaultValues?.date?.endDate}
                  rp={rp}
                  setValue={setValue}
                  name="custom-form-submit-name"
                  disabled={opt === OPT_DETAIL}
                />
              )}
              name="date"
              control={control}
              rules={{
                validate: () =>
                  !(
                    !getValues('date') ||
                    !getValues('date').startDate ||
                    !getValues('date').endDate
                  ),
              }}
            />
            <FormHelperText error={Boolean(errors.date)}>
              {errors.date && '日期不得为空'}
            </FormHelperText>
          </FormControl>
        </Box>

        <Box>
          <Controller
            render={(pr) => (
              <UploadImageCom
                uW="200"
                uH="150"
                iW="200"
                iH="150"
                pr={pr}
                label={
                  <>
                    <span style={{ fontSize: '16px' }}>封面图</span>
                    <span style={{ marginLeft: '6px', color: '#999999' }}>
                      建议尺寸1080px*1042px
                    </span>
                  </>
                }
                required={true}
                disabled={opt === OPT_DETAIL}
                getValues={getValues}
                maxNumber="1"
                handlePreview={handlePreview}
                defaultValues={defaultValues?.coverImage}
              />
            )}
            name="coverImage"
            control={control}
            rules={{
              required: true,
            }}
          />
          <FormHelperText error={Boolean(errors.coverImage)}>
            {errors.coverImage && '请选择封面图'}
          </FormHelperText>
        </Box>

        <Box>
          <Controller
            render={(pr) => (
              <UploadImageCom
                uW="150"
                uH="150"
                iW="150"
                iH="150"
                pr={pr}
                label={
                  <>
                    <span style={{ fontSize: '16px' }}>详情图</span>
                    <span style={{ marginLeft: '6px', color: '#999999' }}>
                      建议尺寸1080px*1042px
                    </span>
                  </>
                }
                showSuccessNumber={true}
                required={true}
                disabled={opt === OPT_DETAIL}
                getValues={getValues}
                maxNumber="10"
                handlePreview={handlePreview}
                defaultValues={defaultValues?.images}
              />
            )}
            name="images"
            control={control}
            rules={{
              required: true,
            }}
          />
          <FormHelperText error={Boolean(errors.images)}>
            {errors.images && '请选择详情图'}
          </FormHelperText>
        </Box>
      </Box>
      <Box
        sx={{
          color: '#212121',
          fontSize: '18px',
          fontWeight: '600',
          marginBottom: '18px',
          marginTop: '28px',
        }}
      >
        礼品兑换规则
      </Box>
      <Box>
        <CheckBoxFieldCom
          getValues={getValues}
          setValue={setValue}
          name="rule"
          control={control}
          checkedBoxList={[
            { label: '仅限新会员兑换', value: '1' },
            { label: '仅限老会员兑换', value: '2' },
            {
              label: (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <span>会员剩余可用积分满</span>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TextFieldCom
                      sx={{ width: '110px' }}
                      label=""
                      control={control}
                      name="minPoint"
                      setValue={setValue}
                      getValues={getValues}
                      thousands={true}
                      isPositiveNumber={true}
                      isNumber={true}
                      disabled={opt === OPT_DETAIL}
                      errors={errors}
                      defaultValue="0"
                      isAdditionalRequired={!getValues('rule')}
                      initErrorText="必填项"
                      rules={{
                        max: getValues('rule')?.includes('3') ? 999999 : '',
                        min: getValues('rule')?.includes('3') ? 1 : '',
                        required: getValues('rule')?.includes('3'),
                      }}
                    />
                    <span
                      style={{
                        color: 'rgba(0,0,0,0.87)',
                        fontSize: '16px',
                        marginLeft: '6px',
                      }}
                    >
                      的会员可兑换
                    </span>
                  </Box>
                </Box>
              ),
              value: '3',
            },
            {
              label: (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <span>每人最多兑换</span>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <TextFieldCom
                      sx={{ width: '110px' }}
                      label=""
                      control={control}
                      name="personalGiftClaimLimit"
                      setValue={setValue}
                      getValues={getValues}
                      thousands={true}
                      isPositiveNumber={true}
                      isNumber={true}
                      disabled={opt === OPT_DETAIL}
                      errors={errors}
                      defaultValue="0"
                      isAdditionalRequired={!getValues('rule')}
                      initErrorText="必填项"
                      rules={{
                        max: getValues('rule')?.includes('5') ? 999999 : '',
                        min: getValues('rule')?.includes('5') ? 1 : '',
                        required: getValues('rule')?.includes('5'),
                      }}
                    />
                    <span
                      style={{
                        color: 'rgba(0,0,0,0.87)',
                        fontSize: '16px',
                        marginLeft: '6px',
                      }}
                    >
                      个
                    </span>
                  </Box>
                </Box>
              ),
              value: '5',
            },
            {
              label: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: '2px',
                  }}
                >
                  指定
                  <Box sx={{ width: '110px' }}>
                    <SelectFieldCom
                      typeList={memberLevels.map((item) => ({
                        value: String(item.code),
                        name: item.name,
                      }))}
                      label="选择等级"
                      name="levels"
                      control={control}
                      setValue={setValue}
                      watchAllFields={watchAllFields}
                      errors={errors}
                      disabled={opt === OPT_DETAIL}
                      rules={{
                        required: getValues('rule')?.includes('4'),
                      }}
                    />
                  </Box>
                  及以上会员可兑换
                </div>
              ),
              value: '4',
            },
            { label: '限888VIP可兑', value: '888' },
          ]}
          disabled={opt === OPT_DETAIL}
        />
      </Box>

      <DialogMl onClose={handlePreviewClose} visible={previewOpen}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            alt=""
            src={previewUrl}
            style={{
              maxWidth: `${clientWidth * 0.6}px`,
              maxHeight: `${clientHeight * 0.6}px`,
              margin: 'auto',
            }}
          />
        </div>
      </DialogMl>
      {openModal && (
        <CouponModal
          open={openModal}
          onClose={handleCloseModal}
          onConfirm={onConfirm}
          title="选择优惠券"
          selectedIds={couponInfo?.id ? [couponInfo.id] : []}
        />
      )}
    </Box>
  );
};
